
import ContratosFacturas from '../../components/bodyBlocks/profesionalBlock/contratosFacturas/ContratosFacturas';
import '../../index.css'

function ContratosFacturasPag() {
  return (
    <div className='pt-20'>
      <ContratosFacturas />
    </div>
   
  );
};

export default ContratosFacturasPag
